import(/* webpackMode: "eager" */ "/var/www/restroagent/src/app/(landing)/blog/page.tsx");
